export const enum TextSnippetsListMenuActions {
    DELETE = 'delete',
}
